// #region Global Imports
import React from 'react';
// #endregion Global Imports
// #region Local Imports
import isEmpty from 'lodash/isEmpty';
import type { ParagraphsPostFragment } from '@components/Paragraphs';
import { Paragraphs } from '@components/Paragraphs';
import { gql } from '@generated/gql';
import type { FragmentType } from '@generated/fragment-masking';
import { getFragmentData } from '@generated/fragment-masking';
import type { IProps } from '@components/PostContent/PostContent';
import type { AuthorsFragment } from '@components/Authors/Authors';
import { AuthorList } from '@components/Authors/Authors';
import { Popper } from '@components/PostContent/Popper';
import styles from './PostContent.module.sass';
// #endregion Local Imports

export const PostContentFragment = gql(/* GraphQL */ `
  fragment PostContentFragment on NodePost {
    id: uuid
    entityUrl {
      path
    }

    title
    lead: fieldLead

    paragraphs: fieldContent {
      entity {
        uuid: entityUuid
        ...ParagraphFragment
      }
    }

    authors: fieldAuthors {
      ...AuthorFragment
    }

    ...PostMetaFragment
    ...PostAfterMetaFragment
  }
`);

export const PostContent: React.FC<IProps.PostContent> = ({
  postContentEntity: _postContentEntity,
  _propperEnable,
}) => {
  const postContentEntity = getFragmentData(
    PostContentFragment,
    _postContentEntity,
  );

  return (
    <>
      {!isEmpty(postContentEntity.title) ? (
        <h1 className={styles.PostContent__headline} id="index">
          {postContentEntity.title}
        </h1>
      ) : null}

      {!isEmpty(postContentEntity.authors) ? (
        <p>
          <AuthorList
            entity={postContentEntity as FragmentType<typeof AuthorsFragment>}
            style="postContent"
          />
        </p>
      ) : null}

      {!isEmpty(postContentEntity.lead) ? (
        <div
          className={styles.PostContent__lead}
          dangerouslySetInnerHTML={{ __html: String(postContentEntity.lead) }}
        />
      ) : null}

      {!isEmpty(postContentEntity.paragraphs) ? (
        <>
          <Paragraphs
            entity={
              postContentEntity as FragmentType<typeof ParagraphsPostFragment>
            }
          />
          <Popper />
        </>
      ) : null}
    </>
  );
};
